import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-entry-list-item',
  templateUrl: './entry-list-item.component.html',
  styleUrls: ['./entry-list-item.component.scss']
})
export class EntryListItemComponent {
  @Input() title?: string;
}
